import { Controller } from "@hotwired/stimulus"

// Sends a chosen folder's relative paths alongside its files.
//
//   <div data-controller="folder-upload">
//     <input type="file" webkitdirectory multiple
//            data-folder-upload-target="input" data-action="folder-upload#describe">
//     <p data-folder-upload-target="summary"></p>
//   </div>
//
// A directory input posts each file under its basename only — the path that says
// which of them is references/REFERENCE.md lives on the File object and nowhere
// in the request. So this reads `webkitRelativePath` and appends a hidden field
// per file, in the same order the browser will post them, and the controller
// pairs them up by index.
//
// Everything else about the form is ordinary: no JavaScript here builds a
// request, and the zip and paste inputs need none of this at all.
export default class extends Controller {
  static targets = ["input", "summary", "paths"]

  describe() {
    const files = Array.from(this.inputTarget.files || [])

    this.pathsTarget.replaceChildren()

    if (files.length === 0) {
      this.summaryTarget.textContent = ""
      return
    }

    files.forEach((file) => {
      const field = document.createElement("input")
      field.type = "hidden"
      field.name = "folder_paths[]"
      // The fallback matters: Firefox supports the picker but has only recently
      // populated webkitRelativePath, and a bare filename is still a usable
      // root-level entry.
      field.value = file.webkitRelativePath || file.name
      this.pathsTarget.append(field)
    })

    const hasManifest = files.some((file) =>
      (file.webkitRelativePath || file.name).split("/").pop().toLowerCase() === "skill.md"
    )

    const count = `${files.length} file${files.length === 1 ? "" : "s"}`
    this.summaryTarget.textContent = hasManifest
      ? `${count} selected.`
      : `${count} selected — no SKILL.md among them, so there is nothing to read.`
  }
}
